<template>
    <Section 
        v-if="jumpLink"
        :width="sectionWidth" 
        class="jump-link-button-wrapper"
    >
        <a 
            v-scroll-to="jumpLink.id" 
            href="#" 
            class="jump-link-button btn"
            :class="`btn-${buttonStyle}`"
        >
            {{ jumpLink.linkText }}
            <i class="fas fa-chevrons-down icon" />
        </a>
    </Section>
</template>

<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        },
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        sectionWidth() {
            return this.slice.primary.slice_width ?? 'sm';
        },
        jumpLink() {
            const slice = this.document.data.body.find(
                slice => slice.slice_type === 'table_of_contents_link' && slice.primary.featured_link
            );

            if (!slice) {
                return null;
            }

            const linkText = this.$validateText(this.slice.primary.featured_link_text) 
                ? this.slice.primary.featured_link_text
                : slice.primary.link_text;

            return {
                id: `#${this.$formatId(slice.id)}`,
                linkText: linkText
            };
        },
        buttonStyle() {
            return this.$validateText(this.slice.primary.button_style) 
                ? this.slice.primary.button_style
                : 'white';
        }
    }
};
</script>
<style lang="scss" scoped>
.jump-link-button-wrapper::v-deep {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 40px;
    font-family: $fontText;

    @include device(pad) {
        margin-top: 48px;
    }
    
    .jump-link-button {
        display: flex;
        align-items: center;
        gap: .75rem;
        padding: 16px 24px;
        box-shadow: $bxs;
        @include border-radius(3px);
        width: fit-content;
        
        &.btn-white {
            color: $font;
            &:hover {
                color: $white;
                background-color: $pink;
            }
        }

        .icon {
            margin-left: 0;
            color: inherit;
        }
    }
}
</style>